<template>
  <div class="breadcrumbs--container">
    <div class="breadcrumbs--block">
      <div v-for="item in mainData" :key="item.block" class="item" :class="{active: item.active === true}">
        <div class="line"></div>
        <div class="name">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  components: {},
  data() {
    return {};
  },
  props: {
    show: Boolean,
    crumbs: Array, // Все возможные стадии, с полем name
    mapping: Array // Маппинг
  },
  watch: {},
  computed: {
    mainData(){
      let result = [];
      for(let keyMap in this.mapping){
        for(let keyCrumb in this.crumbs){
          if(this.mapping[keyMap] === this.crumbs[keyCrumb].block){
            result.push(this.crumbs[keyCrumb]);
          }
        }
      }
      return result;
    }
  },
  methods: {},
  created() {}
};
</script>

<style scoped lang="less">
.breadcrumbs--block{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  .item{
    width: 100%;
    text-align: center;
    font-size: 14px;

    .line{
      height: 3px;
      background-color: #E2E7ED;
    }
    .name{
      color: #C4C4C4;
    }
  }
  .item.active{
    .line{
      background-color: #41A2FC;
    }
    .name{
      color: #4F4F4F;
    }
  }
}
</style>
